<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" hide-details />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <SectionSettingsContainerFuild :settings="fields.settings" :container-page="fields.containerPage" />
        </div>

        <div class="mb-4">
          <div class="d-flex align-center mb-2" style="gap: 10px">
            <label class="label-input mb-0">Title Banner</label>
            <input type="checkbox" v-model="fields.titleBanner.show" />
          </div>
          <div class="group-item">
            <ckeditor :editor="editor" v-model="fields.titleBanner.content" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-4">
          <div class="d-flex justify-space-between align-center">
            <div class="d-flex align-center" style="gap: 10px">
              <label class="label-input mb-0">Key Features</label>
              <input type="checkbox" v-model="fields.keyFeatures.show" />
            </div>
            <v-btn small text color="primary" @click="handleAddKeyFeature">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Item</span>
            </v-btn>
          </div>
          <div class="group-item">
            <v-expansion-panels accordion class="mt-2">
              <v-expansion-panel v-for="(item, index) in fields.keyFeatures.items" :key="`key-feature-${index}`">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center">
                    <span>Feature {{ index + 1 }}</span>
                    <v-btn icon @click.stop="handleRemoveKeyFeature(index)">
                      <v-icon size="18" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="mb-3">
                    <label class="mb-2 d-block">Icon</label>
                    <UploadImage
                      @callback="obj => handleUploadKeyFeatureIcon(obj, index)"
                      :image="{ imageSrc: item.icon || '' }"
                      :height="`120`"
                      :typeUpload="'image'"
                      @callbackDelete="() => handleRemoveKeyFeatureIcon(index)"
                    />
                  </div>
                  <label class="mb-2 d-block">Content</label>
                  <ckeditor :editor="editor" v-model="item.content" :config="editorConfig" />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>

        <div class="mb-4">
          <div class="d-flex align-center mb-2" style="gap: 10px">
            <label class="label-input mb-0">Small Banner Image</label>
            <input type="checkbox" v-model="fields.imgSmallBanner.show" />
          </div>
          <div class="group-item">
            <UploadImage
              @callback="handleUploadSmallBanner"
              :image="{ imageSrc: fields.imgSmallBanner.src }"
              :height="`160`"
              :typeUpload="'image'"
              @callbackDelete="handleRemoveSmallBanner"
            />
            <v-text-field
              class="mt-4"
              v-model.number="fields.imgSmallBanner.maxWidthSmall"
              type="number"
              label="Max width (small screen)"
              min="0"
              suffix="px"
              hide-details
            />
          </div>
        </div>

        <div class="mb-4">
          <ButtonPrimary :button="fields.button" />
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { updateHtmlFromData } from '../common/html/update';
import ButtonPrimary from './common/button-primary.vue';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';

export default {
  name: 'banner-fastvaluedeal-section-editor',
  components: {
    UploadImage,
    SectionSettingsContainerFuild,
    ButtonPrimary,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Banner FastValueDeal Section',
        enableAnchor: false,
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#FFFFFF',
          textColor: '#000000',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
        },
        containerPage: {
          enableStyle: false,
          background: '#FFFFFF',
        },
        titleBanner: {
          show: true,
          content:
            '<h2>Access 100+ Tv Channels Paying ZERO For Cable Fees</h2><p>Watch Movies, Sports, TV Shows, News For Free</p>',
        },
        keyFeatures: {
          show: true,
          items: [],
        },
        imgSmallBanner: {
          show: true,
          src: '',
          maxWidthSmall: 430,
        },
        button: {
          show: true,
          backgroundColor: '#606F99',
          color: '#FFFFFF',
          radius: 4,
          text: 'Shop Now',
          link: '#',
          iconPrefix: {
            show: false,
            src: '',
          },
          iconSuffix: {
            show: true,
            src: '',
          },
          subBtn: {
            show: false,
            text: '30-Day Money-Back Guararantee',
          },
        },
      },
    };
  },
  mounted() {
    this.applyExtract(this.sectionEditor.sectionExtract);
  },
  watch: {
    sectionEditor: {
      handler(newVal) {
        if (newVal && newVal.sectionExtract) {
          this.applyExtract(newVal.sectionExtract);
        }
      },
      deep: true,
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;
      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        titleBanner: { ...this.fields.titleBanner, ...(extract.titleBanner || {}) },
        keyFeatures: {
          ...this.fields.keyFeatures,
          ...(extract.keyFeatures || {}),
          items: Array.isArray(extract.keyFeatures?.items)
            ? extract.keyFeatures.items.map(it => ({
                icon: it.icon || '',
                content: it.content || '',
              }))
            : [],
        },
        imgSmallBanner: { ...this.fields.imgSmallBanner, ...(extract.imgSmallBanner || {}) },
        button: {
          ...this.fields.button,
          ...(extract.button || {}),
          iconPrefix: { ...this.fields.button.iconPrefix, ...((extract.button || {}).iconPrefix || {}) },
          iconSuffix: { ...this.fields.button.iconSuffix, ...((extract.button || {}).iconSuffix || {}) },
          subBtn: { ...this.fields.button.subBtn, ...((extract.button || {}).subBtn || {}) },
        },
      };
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const payload = {
        ...this.fields,
        keyFeatures: {
          ...this.fields.keyFeatures,
          items: (this.fields.keyFeatures.items || []).map(it => ({
            icon: it.icon || '',
            content: it.content || '',
          })),
        },
      };
      const updateHtml = updateHtmlFromData.sectionBannerFastvaluedeal(this.sectionEditor.section.html, payload);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleAddKeyFeature() {
      this.fields.keyFeatures.items.push({
        icon: 'https://cdn.skyfastimg.com/images/2026/05/28/image-6a17b76b53e44f66bdac23fb.png',
        content: '<h3>Powerful 120 PSI</h3>',
      });
    },
    handleRemoveKeyFeature(index) {
      this.fields.keyFeatures.items.splice(index, 1);
    },
    handleUploadKeyFeatureIcon(obj, index) {
      if (!this.fields.keyFeatures.items[index]) return;
      this.$set(this.fields.keyFeatures.items[index], 'icon', obj.imageSrc || '');
    },
    handleRemoveKeyFeatureIcon(index) {
      if (!this.fields.keyFeatures.items[index]) return;
      this.$set(this.fields.keyFeatures.items[index], 'icon', '');
    },
    handleUploadSmallBanner(obj) {
      this.fields.imgSmallBanner.src = obj.imageSrc || '';
    },
    handleRemoveSmallBanner() {
      this.fields.imgSmallBanner.src = '';
    },
  },
};
</script>

<style scoped lang="scss">
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
